module.exports = __webpack_public_path__ + "static/media/intro-windows.a12771bc.webp";